import { render, staticRenderFns } from "./CommentsThread.vue?vue&type=template&id=fbb7ebbe&scoped=true"
import script from "./CommentsThread.vue?vue&type=script&lang=js"
export * from "./CommentsThread.vue?vue&type=script&lang=js"
import style0 from "./CommentsThread.vue?vue&type=style&index=0&id=fbb7ebbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb7ebbe",
  null
  
)

export default component.exports